<template>
  <TableLayout :permissions="['meihui:templateStyle:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="模板ID"><el-input v-model="searchForm.templateId" placeholder="模板ID" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建模板样式')"" icon="el-icon-plus" v-permissions="['meihui:templateStyle:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:templateStyle:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="templateId" label="模板ID" width="100" show-overflow-tooltip />
        <el-table-column prop="templateCode" label="编码" width="150" show-overflow-tooltip />
        <el-table-column prop="bgColor" label="背景色" width="100" show-overflow-tooltip />
        <el-table-column prop="accentColor" label="强调色" width="100" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑模板样式', row)"" icon="el-icon-edit" v-permissions="['meihui:templateStyle:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:templateStyle:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operatemplateStyleWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operatemplateStyleWindow from './operatemplateStyleWindow'
export default {
  name: 'TemplateStyle', extends: BaseTable, components: { TableLayout, Pagination, operatemplateStyleWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '模板样式', api: '/rentHouse/templateStyle', 'field.id': 'id', 'field.main': 'id' })
    this.search()
  }
}
</script>